const state = {
  processing: false,
  bulkProcessing: false,
  npses: [],
};

export default state;
